import { render, staticRenderFns } from "./PsychologicalTestDataView.vue?vue&type=template&id=a0a49f18&scoped=true"
import script from "./PsychologicalTestDataView.vue?vue&type=script&lang=js"
export * from "./PsychologicalTestDataView.vue?vue&type=script&lang=js"
import style0 from "./PsychologicalTestDataView.vue?vue&type=style&index=0&id=a0a49f18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a49f18",
  null
  
)

export default component.exports